import React from 'react';

interface SvgProps {
    isTouchable?: boolean;
}

export const Svg: React.FC<SvgProps & React.SVGProps<SVGSVGElement>> = ({
    isTouchable,
    width,
    height,
    style,
    children,
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid"
            viewBox={`0 0 ${width} ${height}`}
            width={width}
            height={height}
            style={{
                touchAction: isTouchable ? 'none' : 'auto',
                WebkitTapHighlightColor: 'transparent',
                WebkitUserSelect: 'none',
                userSelect: 'none',
                display: 'block',
                ...style
            }}
            {...props}
        >
            {children}
        </svg>
    );
};
